module.exports = __webpack_public_path__ + "img/cpany6.5150ba45.png";